import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 44 44" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M29.333 18H14v-2h15.333v2zM23.2 22.6H14v-2h9.2v2zM14 27.2h12.486v-2H14v2z" /></svg>);